import React from 'react'
import { useAtomValue } from 'jotai'

import { Access } from '../../lib'
import * as state from '../../states'
import { TOfferSpendByOfferAggregated } from '../../types'
import { IUiTableConfig, UiTable, UiDateInfo } from '../ui'
import * as helpers from '../../helpers'
import { sortOfferSpendItemsByDate } from './OfferSpendByAccountDetailsTable'
import { ALL_LANG_KEY } from '../../types/lang'
import { useTranslation } from 'react-i18next'

type IOfferSpendByOfferDetailsTableProps = {
	items: Array<TOfferSpendByOfferAggregated>;
	skip: number;
	showDateColumn: boolean;
}

export const OfferSpendByOfferDetailsTable = (props: IOfferSpendByOfferDetailsTableProps) => {
	const {
		items = [],
		skip = 0,
		showDateColumn = false
	} = props
	const { t } = useTranslation()
	const profile = useAtomValue(state.profileAtom)
	const $access = new Access(profile ?? null)

	const tableConfig: IUiTableConfig<TOfferSpendByOfferAggregated>[] = [
		{
			key: 'id',
			title: t(ALL_LANG_KEY.offer_spend_by_offer_details_table.column_id)
		},
		{
			key: 'at',
			title: t(ALL_LANG_KEY.offer_spend_by_offer_details_table.column_date),
			rowCellFormatter: ({ value, rowData }) => {
				return (
					<UiDateInfo value={value}/>
				)
			}
		},
		{
			key: 'amount',
			title: t(ALL_LANG_KEY.offer_spend_by_offer_details_table.column_amount),
			classesToAdd: {
				th: 'text-center',
				td: 'text-center'
			},
			rowCellFormatter: ({ value, rowData }) => {
				const formatValue = helpers.formatAmount(value)

				return <>{helpers.thousandSeparator(formatValue)}</>
			}
		},
		{
			key: 'accountId',
			title: t(ALL_LANG_KEY.offer_spend_by_offer_details_table.column_account),
			rowCellFormatter: ({ rowData }): React.JSX.Element => {
				const accountId = rowData?.accountId ?? null
				const account = rowData?.account ?? null
				// const email = account?.email ?? null
				const auth = account?.auth ?? null
				const login = auth?.login ?? null
				return <>
					<strong>[id: {accountId}]</strong>
					&nbsp;
					{login ?? '?'}
				</>
			}
		},
		{
			key: 'account.extra.keitaroLogin',
			title: t(ALL_LANG_KEY.offer_spend_by_offer_details_table.column_kt_group),
			rowCellFormatter: ({ rowData }) => {
				const extra = rowData?.account?.extra ?? null
				const valueFormat: string = extra?.keitaroLogin ?? ''
				return valueFormat
			}
		},
		{
			key: 'notes',
			title: t(ALL_LANG_KEY.offer_spend_by_offer_details_table.column_notes),
			rowCellFormatter: ({ value, rowData }) => {
				return <>{value ?? ''}</>
			}
		}
	]

	const tableConfigFiltered = tableConfig.filter(item => {
		if (!showDateColumn && item.key === 'at') return false
		return true
	})

	const sortedItemsByDate = sortOfferSpendItemsByDate(items)

	return <>
		<UiTable
			data={sortedItemsByDate}
			config={tableConfigFiltered}
			// TODO: uncomment if necessary
			// classesToAdd={{
			// 	wrapper: 'table-sticky-wrapper table-sticky-wrapper--top-60',
			// }}
		/>
	</>
}